import { ActionSkeleton } from './action-skeleton';
import { AvatarSkeleton } from './avatar-skeleton';
import { BasicSkeleton } from './basic-skeleton';
import { CommentSkeleton } from './comment-skeleton';
import { DetailSkeleton } from './detail-skeleton';
import { DisplaySkeleton } from './display-skeleton';
import { FileSkeleton } from './file-skeleton';
import { FilterSkeleton } from './filter-skeleton';
import { GridSkeleton } from './grid-skeleton';
import { ItemSkeleton } from './item-skeleton';
import { ListSkeleton } from './list-skeleton';
import { LogSkeleton } from './log-skeleton';
import { PhotoSkeleton } from './photo-skeleton';
import { PillSkeleton } from './pill-skeleton';
import { PreviewSkeleton } from './preview-skeleton';
import { SearchSkeleton } from './search-skeleton';
import { SectionSkeleton } from './section-skeleton';
import { SelectSkeleton } from './select-skeleton';
import { TableSkeleton } from './table-skeleton';
import { TextSkeleton } from './text-skeleton';

type SkeletonLayout =
	| 'action'
	| 'avatar'
	| 'basic'
	| 'comment'
	| 'detail'
	| 'display'
	| 'file'
	| 'filter'
	| 'grid'
	| 'item'
	| 'list'
	| 'log'
	| 'photo'
	| 'pill'
	| 'preview'
	| 'search'
	| 'section'
	| 'select'
	| 'table'
	| 'text';

type SkeletonProps = {
	layout?: SkeletonLayout;
	count?: number;
	className?: string;
};

const Skeleton = ({ layout = 'basic', count = 3, className }: SkeletonProps) => {
	switch (layout) {
		case 'action':
			return <ActionSkeleton className={className} />;
		case 'avatar':
			return <AvatarSkeleton className={className} />;
		case 'comment':
			return <CommentSkeleton className={className} />;
		case 'detail':
			return <DetailSkeleton className={className} />;
		case 'display':
			return <DisplaySkeleton className={className} />;
		case 'file':
			return <FileSkeleton className={className} />;
		case 'filter':
			return <FilterSkeleton count={count} className={className} />;
		case 'grid':
			return <GridSkeleton className={className} />;
		case 'item':
			return <ItemSkeleton count={count} className={className} />;
		case 'list':
			return <ListSkeleton className={className} />;
		case 'log':
			return <LogSkeleton className={className} />;
		case 'photo':
			return <PhotoSkeleton className={className} />;
		case 'pill':
			return <PillSkeleton className={className} />;
		case 'preview':
			return <PreviewSkeleton className={className} />;
		case 'search':
			return <SearchSkeleton className={className} />;
		case 'section':
			return <SectionSkeleton count={count} className={className} />;
		case 'select':
			return <SelectSkeleton className={className} />;
		case 'table':
			return <TableSkeleton count={count} className={className} />;
		case 'text':
			return <TextSkeleton className={className} />;
		default:
			return <BasicSkeleton className={className} />;
	}
};

export { Skeleton };
export type { SkeletonLayout, SkeletonProps };
